import cx from "../../utils/tailwind-merge";
import "../../utils/tailwind.css";

export default function FormError(props) {
  const { className, message, show, children, ...restProps } = props;
  const errorMessage = message || children;
  if (!show) return null;
  return (
    <div className={cx("form-error text-red-500 mt-1 text-xs form-field-error", className)} {...restProps}>
      {errorMessage}
    </div>
  );
}
